// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable guard-for-in */
import EventHandler from '../../utils/dom/event-handler';
import { Events } from '../../utils/dom/html-events';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { startLoadingAnimation } from '../../utils/dom/loading';

const SELECTOR_WRAPPER = '.p-tennis-leader-resource-form';
const SELECTOR_FORM_WRAPPER = '.p-tennis-leader-resource-form__wrapper';
const SELECTOR_FORM = '.p-tennis-leader-resource-form__form';
const SELECTOR_FORM_BUTTON = '.p-tennis-leader-resource-form__button';
const SELECTOR_FORM_CONFIRMATION = '.p-tennis-leader-resource-form__confirmation-page';

const IS_LOCAL = false;
const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

class TennisLeaderResourceForm {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.formWrapper = SelectorEngine.findOne(SELECTOR_FORM_WRAPPER, this._wrapper);
		this.form = SelectorEngine.findOne(SELECTOR_FORM, this.formWrapper);
		this.formButton = SelectorEngine.findOne(SELECTOR_FORM_BUTTON, this._wrapper);
		this._successContainer = SelectorEngine.findOne(SELECTOR_FORM_CONFIRMATION, this._wrapper);
		this._errorContainer = SelectorEngine.findOne('.p-tennis-leader-resource-form__wrapper-error-container', this.formWrapper);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});
		this.getFormDetails();
	}

	async getFormDetails() {
		try {
			const url = '/api/tennisLeaderResourceForm/steps';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				// eslint-disable-next-line no-console
				console.log('Error :', error);
			}
		}
	}

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.form, {
			questions: stepsData,
			totalSteps: 1,
			hasSeparator: false,
			formType: FormTypes.SectionForm,
			isHideProgress: true,
			isRenderDependentQuestion: false,
			saveAddress: false
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});
		EventHandler.on(this.formButton, Events.Click, () => {
			const isFormValid = this.formGenerator.formValidation();
			if (isFormValid) {
				this.submitSupportForm(this.answerList);
			}
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
		this.answerList.isConsent = this.answerList?.isConsent?.[0].id;
		this.answerList.courseDelivery = this.answerList?.courseDelivery.map((item) => item.label);
	}

	async submitSupportForm(answers) {
		startLoadingAnimation(true);

		try {
			const url = `/api/tennisLeaderResourceForm/submit`;
			const responseData = await Request.post(url, answers, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});

			const { success } = responseData;
			if (success) {
					this.formWrapper.classList.add('u-hidden');
					this._successContainer.classList.remove('u-hidden');
					this._successContainer.scrollIntoView();
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorContainer.scrollIntoView();
			}
		}
		catch {
			this._errorContainer.classList.remove('u-hidden');
			this.formWrapper.scrollIntoView();
		}
	}
}

const globalTennisLeaderResourceForm = new TennisLeaderResourceForm();
export default globalTennisLeaderResourceForm;
